<template>
  <div>
    <form @submit.prevent="onSubmit">
      <ListEdit
        v-model="modelValue"
        label="Preguntas de la evaluación"
        @handleAdd="addQuestion"
        @handleRemove="removeQuestion"
        :minItems="1"
      >
        <template #default="{ index }">
          <div class="d-flex row me-1">
            <div class="col-sm-6 mb-2">
              <label for="descriptionInput">
                <b> Pregunta {{ index + 1 }} </b>
              </label>
              <textarea
                v-model="modelValue[index].description"
                class="form-control form-control-sm"
                id="descriptionInput"
                placeholder="Descripción de la pregunta"
                rows="4"
                required
              />
            </div>
            <div class="col-sm-6">
              <div>
                <label for="lastNameInput">Tipo</label>
                <select
                  v-model="modelValue[index].type"
                  class="form-select form-select-sm"
                  id="select-age-group"
                  @change="handleTypeChange($event, index)"
                  required
                >
                  <option :value="null" disabled selected>-- Selecciona un tipo de pregunta --</option>
                  <option v-for="questionType in questionTypes"
                    :key="questionType.id"
                    :value="questionType.id"
                    :label="questionType.name"
                  />
                </select>
              </div>
              
              <div class="mt-1">
                <BooleanQuestion
                  v-if="modelValue[index].type === 'bool'"
                  :question="modelValue[index]"
                  @input="handleOptionsInput($event, index)"
              
                />
                <SingleChoiceQuestion
                  v-else-if="modelValue[index].type === 'select'"
                  :question="modelValue[index]"
                  @input="handleOptionsInput($event, index)"
                />
              </div>
            </div>
            

          </div>
          <hr v-if="index < modelValue.length - 1">
        </template>
        
      </ListEdit>
      
      <div class="d-flex row align-items-center">
          <div class="col-auto">
              <button type="submit" class="btn btn-success">
                  Guardar
              </button>
          </div>
          <div class="col-sm flex-grow-1">
              <AlertDismiss ref="alert"/>
          </div>
      </div>
    </form>
  </div>
</template>

<script>
import ListEdit from '@/components/shared/List-edit.vue';
import BooleanQuestion from './CurriculumAssesment-form.vue/Boolean-question.vue';
import SingleChoiceQuestion from './CurriculumAssesment-form.vue/Single-choice-question.vue';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import {EventNames} from '@/plugins/enums/index.js'

export default {
  name: 'CurriculumAssesmentForm',

  props: {
    value: {
      type: Array,
      required: true,
    },
  },

  components: {
    ListEdit,
    BooleanQuestion,
    SingleChoiceQuestion,
    AlertDismiss
  },

  data() {
    return {
      modelValue: this.value,
      questionTypes: [
        {
          id: 'bool',
          name: 'Verdadero / Falso'
        },
        {
          id: 'select',
          name: 'Selección única'
        }
      ],
    }
  },
  
  mounted() {
    if (this.modelValue.length === 0 ) {
      this.addQuestion();
    }
  },

  methods: {
    onSubmit() {      
      this.$eventBus.$emit(EventNames.SaveChangesCurriculumAssesment);
    },

    addQuestion() {
      this.modelValue.push({
        description: null,
        type: null,
        options: null,
      });
    },

    removeQuestion(index) {
      this.modelValue.splice(index, 1);
    },

    handleOptionsInput(value, index) {
      this.$set(this.modelValue, index, value)
    },

    handleTypeChange(event, index) {
      // reset options
      this.$set(this.modelValue[index], 'options', [])
    }
  },
}
</script>

<style scoped>
hr {
  margin-top: 0rem;
  margin-bottom: 0.5rem;
}
</style>
